/* Fast Fridgespares - "Will it fit your fridge?" checker popup.
 * Reads window.FFS_FIT_DATA (assets/ffs-fit-data.js). */
(function () {
  'use strict';
  if (window.FFSFit) return;
  var D = window.FFS_FIT_DATA;
  if (!D) return;
  var C = D.contact, P = D.products, B = D.brands;

  /* ---------- helpers ---------- */
  function norm(s) { return String(s || '').toUpperCase().replace(/[^A-Z0-9]/g, ''); }
  function esc(s) {
    return String(s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function tokens(raw) { return String(raw || '').toUpperCase().split(/[^A-Z0-9]+/).filter(Boolean); }
  function candidates(raw) {
    var t = tokens(raw), out = {}, i, j, s;
    for (i = 0; i < t.length; i++) {
      s = '';
      for (j = i; j < Math.min(t.length, i + 3); j++) { s += t[j]; out[s] = 1; }
    }
    out[norm(raw)] = 1;
    return Object.keys(out);
  }
  function brandsIn(raw) {
    var low = String(raw || '').toLowerCase(), out = [];
    Object.keys(B).forEach(function (id) {
      if (B[id].alias.some(function (a) { return low.indexOf(a) > -1; })) out.push(id);
    });
    return out;
  }
  function brandLabels(ids) { return ids.map(function (id) { return B[id].label; }); }
  function listText(arr) {
    if (arr.length < 2) return arr.join('');
    return arr.slice(0, -1).join(', ') + ' and ' + arr[arr.length - 1];
  }

  /* ---------- index of every model / part number in the store ---------- */
  var INDEX = [];
  Object.keys(P).forEach(function (h) {
    var e = P[h];
    (e.models || []).forEach(function (m) { INDEX.push({ h: h, k: norm(m), label: m, tier: 'listed' }); });
    (e.reported || []).forEach(function (m) { INDEX.push({ h: h, k: norm(m), label: m, tier: 'reported' }); });
    (e.parts || []).forEach(function (m) { INDEX.push({ h: h, k: norm(m), label: m, tier: 'part' }); });
  });

  function lookup(raw) {
    var c = candidates(raw), seen = {}, hits = [];
    INDEX.forEach(function (x) {
      var key = x.h + '|' + x.tier + '|' + x.k;
      if (x.k.length >= 3 && c.indexOf(x.k) > -1 && !seen[key]) { seen[key] = 1; hits.push(x); }
    });
    return hits;
  }
  function suggestions(raw) {
    var c = candidates(raw).filter(function (s) { return s.length >= 4; }), out = [], seen = {};
    INDEX.forEach(function (x) {
      if (x.tier === 'part') return;
      c.forEach(function (s) {
        if (x.k !== s && x.k.indexOf(s) === 0 && !seen[x.k]) { seen[x.k] = 1; out.push(x.label); }
      });
    });
    return out.slice(0, 4);
  }

  /* ---------- decide the result ---------- */
  function evaluate(handle, raw) {
    var e = P[handle] || { kind: 'exact', name: 'this part', models: [], reported: [], parts: [], brands: [], compare: [] };
    var hits = lookup(raw), typedBrands = brandsIn(raw);
    var mineListed = hits.filter(function (x) { return x.h === handle && x.tier === 'listed'; })[0];
    var minePart = hits.filter(function (x) { return x.h === handle && x.tier === 'part'; })[0];
    var mineReported = hits.filter(function (x) { return x.h === handle && x.tier === 'reported'; })[0];
    var others = hits.filter(function (x) { return x.h !== handle && P[x.h].kind !== 'generic'; });
    var brandHit = typedBrands.filter(function (b) { return (e.brands || []).indexOf(b) > -1; });
    var r = { entry: e, typedBrands: typedBrands, brandHit: brandHit, others: others, related: others, hits: hits };
    if (e.kind === 'generic') { r.status = 'generic'; return r; }

    if (mineListed) {
      r.status = 'listed';
      r.matched = mineListed.label;
    } else if (minePart) {
      r.status = 'part';
      r.matched = minePart.label;
    } else if (mineReported) {
      r.status = 'reported';
      r.matched = mineReported.label;
    } else {
      var sug = suggestions(raw);
      if (sug.length && !others.length) { r.status = 'suggest'; r.suggest = sug; }
      else if (others.length) { r.status = 'other'; }
      else if (brandHit.length && (e.kind === 'universal' || e.kind === 'sized')) { r.status = 'brand'; }
      else if (e.kind === 'universal') { r.status = 'universal'; }
      else { r.status = 'none'; }
    }
    return r;
  }

  /* ---------- copy for each result ---------- */
  var ICON = {
    ok: '<svg viewBox="0 0 24 24" aria-hidden="true"><circle cx="12" cy="12" r="11" fill="currentColor"/><path d="M7 12.5l3.2 3.2L17 8.8" fill="none" stroke="#fff" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"/></svg>',
    info: '<svg viewBox="0 0 24 24" aria-hidden="true"><circle cx="12" cy="12" r="11" fill="currentColor"/><path d="M12 11v6M12 7.2v.1" fill="none" stroke="#fff" stroke-width="2.4" stroke-linecap="round"/></svg>',
    warn: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 2.6l10.2 17.6H1.8L12 2.6z" fill="currentColor"/><path d="M12 9.4v5M12 17.2v.1" fill="none" stroke="#fff" stroke-width="2.4" stroke-linecap="round"/></svg>'
  };

  function checks(e, title) {
    if (!e.compare || !e.compare.length) return '';
    return '<div class="ffs-fit__box"><p class="ffs-fit__box-title">' + esc(title) + '</p><ul class="ffs-fit__checks">' +
      e.compare.map(function (c) { return '<li><span>' + esc(c[0]) + '</span><strong>' + esc(c[1]) + '</strong></li>'; }).join('') +
      '</ul></div>';
  }
  function chips(arr) {
    return '<ul class="ffs-fit__chips">' + arr.map(function (m) { return '<li>' + esc(m) + '</li>'; }).join('') + '</ul>';
  }
  function productLinks(list, handle) {
    var seen = {}, rows = '';
    list.forEach(function (x) {
      if (seen[x.h]) return; seen[x.h] = 1;
      rows += '<li><a href="/products/' + esc(x.h) + '">' + esc(P[x.h].name) + '</a>' +
        '<span>' + (x.tier === 'reported' ? 'reported for ' : x.tier === 'part' ? 'part number ' : 'listed for ') + esc(x.label) + '</span></li>';
    });
    return '<ul class="ffs-fit__links">' + rows + '</ul>';
  }
  function relatedBox(r, M, handle) {
    if (!r.related || !r.related.length) return '';
    return '<div class="ffs-fit__box ffs-fit__box--note"><p class="ffs-fit__box-title">Other parts we list for ' + M + '</p>' +
      productLinks(r.related, handle) + '</div>';
  }
  function confirmNote() {
    return 'Not sure? Send us your model number and a photo of your old part. Our team checks it for free before you order.';
  }

  function view(state) {
    var raw = state.model, r = state.result, e = r.entry || {}, M = esc(raw);
    var v = { tone: 'info', icon: 'info', title: '', body: '', extra: '', actions: [] };
    var add = { act: 'add', label: 'Add to cart', kind: 'primary' };
    var confirm = { act: 'confirm', label: 'Confirm my model (free)', kind: 'primary' };
    var confirm2 = { act: 'confirm', label: 'Ask us to double-check', kind: 'secondary' };

    switch (r.status) {
      case 'listed':
        v.tone = 'ok'; v.icon = 'ok';
        v.title = 'Exact match. This part fits your ' + esc(r.matched) + '.';
        v.body = '<p>Your model <strong>' + esc(r.matched) + '</strong> is on our compatibility list for the ' + esc(e.name) + '. As a final check, your old part should match the details below.</p>';
        v.extra = checks(e, 'Match these on your old part') + relatedBox(r, esc(r.matched), state.handle);
        v.actions = [add, confirm2];
        break;

      case 'generic':
        v.tone = 'ok'; v.icon = 'ok';
        v.title = 'This product is not model specific.';
        v.body = '<p>The ' + esc(e.name) + ' is a general purpose product, so it does not depend on your fridge model (' + M + '). Check the size and rating on the product page suit your job.</p>';
        v.actions = [add, confirm2];
        break;

      case 'part':
        v.tone = 'ok'; v.icon = 'ok';
        v.title = 'You are on the right page.';
        v.body = '<p><strong>' + esc(r.matched) + '</strong> is the part number of this product (' + esc(e.name) + ').</p>';
        v.extra = checks(e, 'Match these on your old part');
        v.actions = [add, confirm2];
        break;

      case 'reported':
        v.tone = 'warn'; v.icon = 'warn';
        v.title = 'Likely fit. We would like to confirm ' + esc(r.matched) + ' for you.';
        v.body = '<p>Other suppliers report the ' + esc(e.name) + ' as compatible with <strong>' + esc(r.matched) + '</strong>, but we have not verified it ourselves yet. Send us your model and we will confirm before you order.</p>';
        v.extra = checks(e, 'Match these on your old part') + relatedBox(r, esc(r.matched), state.handle);
        v.actions = [confirm, { act: 'add', label: 'Add to cart anyway', kind: 'secondary' }];
        break;

      case 'suggest':
        v.tone = 'info'; v.icon = 'info';
        v.title = 'Did you mean one of these models?';
        v.body = '<p>We could not find <strong>' + M + '</strong> exactly. Pick the model on your fridge\'s rating label:</p>' +
          '<ul class="ffs-fit__chips ffs-fit__chips--pick">' + r.suggest.map(function (m) {
            return '<li><button type="button" data-act="pick" data-model="' + esc(m) + '">' + esc(m) + '</button></li>';
          }).join('') + '</ul>';
        v.actions = [confirm];
        break;

      case 'other':
        v.tone = 'info'; v.icon = 'info';
        v.title = 'Your model is listed for a different part.';
        v.body = '<p><strong>' + M + '</strong> is on our list for the part' + (r.others.length > 1 ? 's' : '') + ' below, not for the ' + esc(e.name) + '.</p>';
        v.extra = productLinks(r.others, state.handle);
        if (e.kind === 'sized' && r.brandHit.length) {
          v.extra += '<p class="ffs-fit__small">This part (' + esc(e.name) + ') only suits if your old element matches ' + esc(e.compare.slice(0, 2).map(function (c) { return c[1]; }).join(' and ')) + '.</p>';
        }
        v.actions = [{ act: 'view', label: 'View the right part', kind: 'primary', href: '/products/' + r.others[0].h }, { act: 'confirm', label: 'Confirm my model (free)', kind: 'secondary' }];
        break;

      case 'brand':
        v.tone = 'info'; v.icon = 'info';
        var bl = listText(brandLabels(r.brandHit));
        v.title = bl + ' is on this part\'s list. Check the details below.';
        v.body = '<p>' + esc(e.blurb || (e.name + ' is listed for ' + bl + '.')) + ' We cannot match <strong>' + M + '</strong> automatically, so the specs on your old part decide the fit.</p>';
        v.extra = checks(e, 'Match these on your old part');
        v.actions = [{ act: 'add', label: 'My old part matches. Add to cart', kind: 'primary' }, { act: 'confirm', label: 'Confirm my model (free)', kind: 'secondary' }];
        break;

      case 'universal':
        v.tone = 'info'; v.icon = 'info';
        v.title = 'This part is chosen by specs, not model number.';
        v.body = '<p>' + esc(e.blurb || '') + ' We cannot match <strong>' + M + '</strong> automatically. Compare the details below with the label or markings on your old part.</p>';
        v.extra = checks(e, 'Match these on your old part');
        v.actions = [{ act: 'add', label: 'My old part matches. Add to cart', kind: 'primary' }, { act: 'confirm', label: 'Confirm my model (free)', kind: 'secondary' }];
        break;

      default: /* none */
        v.tone = 'warn'; v.icon = 'warn';
        v.title = 'We cannot confirm ' + M + ' for this part yet.';
        v.body = '<p><strong>' + M + '</strong> is not on this part\'s compatibility list' +
          (r.brandHit && r.brandHit.length ? ', even though the brand (' + esc(listText(brandLabels(r.brandHit))) + ') is right' : '') +
          '. Please do not order yet. Send us your model number and we will tell you the right part.</p>';
        var listed = (e.models || []).concat(e.reported || []);
        if (listed.length) {
          v.extra = '<div class="ffs-fit__box"><p class="ffs-fit__box-title">' + ((e.models || []).length ? 'Models this part is listed for' : 'Models customers commonly use this part with') + '</p>' + chips(listed) + '</div>';
        }
        v.actions = [{ act: 'confirm', label: 'Find my part. We will guide you', kind: 'primary' }];
    }
    return v;
  }

  /* ---------- dialog ---------- */
  var dlg, state = { handle: '', title: '', model: '', result: null, trigger: null };

  function build() {
    if (dlg) return;
    dlg = document.createElement('dialog');
    dlg.className = 'ffs-fit';
    dlg.setAttribute('aria-labelledby', 'ffs-fit-title');
    dlg.innerHTML =
      '<div class="ffs-fit__panel">' +
        '<button type="button" class="ffs-fit__close" data-act="close" aria-label="Close fit check">' +
          '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round"/></svg></button>' +
        '<p class="ffs-fit__eyebrow">Fit check</p>' +
        '<h2 class="ffs-fit__heading" id="ffs-fit-title">Will it fit your fridge?</h2>' +
        '<p class="ffs-fit__product" data-role="product"></p>' +
        '<form class="ffs-fit__form" novalidate>' +
          '<label for="ffs-fit-model">Your fridge model number</label>' +
          '<div class="ffs-fit__row"><input id="ffs-fit-model" type="text" maxlength="100" autocomplete="off" placeholder="e.g. RJ422V" />' +
          '<button type="submit">Check</button></div>' +
        '</form>' +
        '<div class="ffs-fit__result" data-role="result" aria-live="polite"></div>' +
        '<div class="ffs-fit__actions" data-role="actions"></div>' +
        '<div class="ffs-fit__foot">' +
          '<p>' + esc(confirmNote()) + '</p>' +
          '<p class="ffs-fit__contact"><a href="' + esc(C.modelGuide) + '">Where is my model number?</a>' +
          '<a href="tel:' + esc(C.phoneHref) + '">Call ' + esc(C.phone) + '</a>' +
          '<a href="mailto:' + esc(C.email) + '">Email us</a></p>' +
        '</div>' +
      '</div>';
    document.body.appendChild(dlg);

    dlg.addEventListener('click', function (ev) {
      if (ev.target === dlg) { dlg.close(); return; }
      var t = ev.target.closest('[data-act]');
      if (!t) return;
      var act = t.getAttribute('data-act');
      if (act === 'close') dlg.close();
      else if (act === 'pick') { setModel(t.getAttribute('data-model')); run(); }
      else if (act === 'add') addToCart();
      else if (act === 'confirm') goFind();
      else if (act === 'view') track('view_alt'); /* link navigates normally */
    });
    dlg.querySelector('form').addEventListener('submit', function (ev) {
      ev.preventDefault();
      var v = dlg.querySelector('#ffs-fit-model').value.trim();
      if (!v) { dlg.querySelector('#ffs-fit-model').focus(); return; }
      state.model = v; run();
    });
    dlg.addEventListener('close', function () {
      syncBack();
      if (state.trigger && state.trigger.focus) { try { state.trigger.focus(); } catch (e) {} }
    });
  }

  function setModel(m) { state.model = m; dlg.querySelector('#ffs-fit-model').value = m; }
  function syncBack() {
    var inputs = document.querySelectorAll('[data-fit-box] [data-model]');
    for (var i = 0; i < inputs.length; i++) inputs[i].value = state.model;
  }

  function track(what) {
    try {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: 'ffs_fit_check', fit_event: what, fit_status: state.result && state.result.status,
        fit_model: state.model, fit_product: state.handle
      });
    } catch (e) {}
  }

  function run() {
    state.result = evaluate(state.handle, state.model);
    var v = view(state);
    var res = dlg.querySelector('[data-role="result"]');
    res.className = 'ffs-fit__result ffs-fit__result--' + v.tone;
    res.innerHTML = '<div class="ffs-fit__status"><span class="ffs-fit__icon">' + ICON[v.icon] + '</span>' +
      '<div><h3>' + v.title + '</h3>' + v.body + '</div></div>' + v.extra;

    var canAdd = !!document.querySelector('[data-add-button]:not([disabled])');
    var html = '';
    v.actions.forEach(function (a) {
      if (a.act === 'add' && !canAdd) return;
      var cls = 'ffs-fit__btn ffs-fit__btn--' + a.kind;
      if (a.href) html += '<a class="' + cls + '" href="' + esc(a.href) + '" data-act="view">' + esc(a.label) + '</a>';
      else html += '<button type="button" class="' + cls + '" data-act="' + a.act + '">' + esc(a.label) + '</button>';
    });
    dlg.querySelector('[data-role="actions"]').innerHTML = html;
    track('result');
  }

  function addToCart() {
    var btn = document.querySelector('[data-add-button]:not([disabled])');
    track('add_to_cart');
    dlg.close();
    if (btn) btn.click();
  }

  function goFind() {
    var e = P[state.handle] || {}, q = [];
    function add(k, val) { if (val) q.push(encodeURIComponent(k) + '=' + encodeURIComponent(val)); }
    var b = brandsIn(state.model);
    add('model', state.model);
    add('product', state.title || e.name);
    add('handle', state.handle);
    add('brand', b.length ? B[b[0]].label : '');
    add('source', 'fit-check');
    add('result', state.result && state.result.status);
    track('find_your_part');
    window.location.href = C.findUrl + '?' + q.join('&');
  }

  function open(opts) {
    build();
    state.handle = opts.handle;
    state.title = opts.title || '';
    state.trigger = opts.trigger || null;
    var e = P[opts.handle];
    dlg.querySelector('[data-role="product"]').textContent = state.title || (e && e.name) || '';
    setModel(opts.model || '');
    run();
    if (typeof dlg.showModal === 'function') dlg.showModal(); else dlg.setAttribute('open', '');
  }

  window.FFSFit = { open: open, _evaluate: evaluate, _lookup: lookup, _norm: norm };

  /* ---------- hook the existing "Check fit" box on product pages ---------- */
  function currentHandle() {
    var m = location.pathname.match(/\/products\/([^\/?#]+)/);
    return m ? decodeURIComponent(m[1]) : '';
  }
  function pageTitle() {
    var h = document.querySelector('.ffs-pi__title') || document.querySelector('h1');
    return h ? h.textContent.replace(/\s+/g, ' ').trim() : '';
  }
  function fromBox(box, trigger) {
    var input = box.querySelector('[data-model]');
    var v = input.value.trim();
    if (!v) {
      input.setCustomValidity('Please enter your fridge model number.');
      input.reportValidity();
      return;
    }
    input.setCustomValidity('');
    open({ handle: currentHandle(), title: pageTitle(), model: v, trigger: trigger });
  }
  document.addEventListener('click', function (ev) {
    var b = ev.target.closest && ev.target.closest('[data-fit-button]');
    var box = b && b.closest('[data-fit-box]');
    if (!box || !currentHandle()) return;
    ev.preventDefault(); ev.stopImmediatePropagation();
    fromBox(box, b);
  }, true);
  document.addEventListener('keydown', function (ev) {
    if (ev.key !== 'Enter') return;
    var t = ev.target;
    if (!t.matches || !t.matches('[data-fit-box] [data-model]') || !currentHandle()) return;
    var box = t.closest('[data-fit-box]');
    ev.preventDefault(); ev.stopImmediatePropagation();
    fromBox(box, box.querySelector('[data-fit-button]'));
  }, true);

  /* ---------- Find Your Part page: prefill from the fit check ---------- */
  function prefill() {
    var form = document.getElementById('FindYourPartForm');
    if (!form) return;
    var q = new URLSearchParams(location.search), model = q.get('model'), product = q.get('product'), handle = q.get('handle');
    if (!model && !product) return;
    function set(id, val) { var el = document.getElementById(id); if (el && !el.value && val) el.value = val; }
    set('fp_model', model);
    set('fp_brand', q.get('brand'));
    set('fp_part', product);
    set('fp_message', 'Hi, I would like to confirm that "' + (product || 'this part') + '" suits my fridge' +
      (model ? ' (model ' + model + ')' : '') + '.' +
      (handle ? ' Product: ' + location.origin + '/products/' + handle + '.' : '') +
      ' Please let me know the right part for my fridge.');
    var note = document.createElement('div');
    note.className = 'ffs-find-context';
    var a = document.createElement('strong'); a.textContent = 'Checking fit: ';
    note.appendChild(a);
    note.appendChild(document.createTextNode((product || 'your part') + (model ? ' for model ' + model : '') + '. Add your contact details and send. We will reply with the right part.'));
    form.parentNode.insertBefore(note, form);
    var n = document.getElementById('fp_name');
    if (n) { try { n.focus({ preventScroll: true }); } catch (e) {} }
    try { note.scrollIntoView({ block: 'center', behavior: 'smooth' }); } catch (e) {}
  }

  function ready() { prefill(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', ready); else ready();
})();
